/*!

=========================================================
* Now UI Dashboard React - v1.5.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/now-ui-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect, useState } from "react";

// reactstrap components
import { Card, CardHeader, CardBody, Row, Col } from "reactstrap";
import { BASE_URL } from "../utils/constants";
// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";

function Groups() {
  const [eduGroups, setEduGroups] = useState([]);
  const [nonEduGroups, setNonEduGroups] = useState([]);
  const uid = localStorage.getItem("user");
  const [showAll, setShowAlll] = useState("");

  useEffect(async () => {
    Swal.showLoading();
    try {
      let res = await axios.get(`${BASE_URL}/group/getgroups.php`);
     
      setEduGroups(res.data.data?.edugroups);
      setNonEduGroups(res.data.data?.nonedugroups);
    } catch {
      Swal.fire("Something Went Wrong", "", "error");
    } finally {
      Swal.close();
    }
  }, []);

  useEffect(async () => {
    getGroups();
  }, [showAll]);

  const getGroups = () => {
    Swal.showLoading();
    axios
      .post(`${BASE_URL}/group/getgroups.php`, { all: showAll })
      .then((res) => {
       
        setEduGroups(res.data.data.edugroups);
        setNonEduGroups(res.data.data.nonedugroups);
      })
      .finally(() => {
        Swal.close();
      });
  };
  return (
    <>
      <PanelHeader size="sm" />
      <div className="content">
        <Row>
          <Col md={12}>
            <Card>
              <CardHeader>
                <h4 className="title">Groups</h4>
              </CardHeader>

              <CardBody className="all-icons">
                <div>
                  <div className="form-check form-check-inline ">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="inlineRadioOptions"
                      id="inlineRadio1"
                      style={{ marginRight: "-20%" }}
                      defaultChecked={true}
                      onChange={(e) => {
                        setShowAlll("");
                      }}
                      value="option1"
                    />
                    <label className="form-check-label" htmlFor="inlineRadio1">
                      Current Groups
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      style={{ marginRight: "-20%" }}
                      className="form-check-input"
                      type="radio"
                      name="inlineRadioOptions"
                      onChange={(e) => {
                        setShowAlll("all");
                      }}
                      id="inlineRadio2"
                      value="option2"
                    />
                    <label className="form-check-label" htmlFor="inlineRadio2">
                      Archived Groups
                    </label>
                  </div>
                </div>
                <Row>
                  {eduGroups?.map((group, key) => {
                   
                    return (
                      <Col
                        md={3}
                        sm={6}
                        xs={12}
                        className="font-icon-list"
                        key={key}
                        style={{ textAlign: "center" }}
                      >
                        <Link to={`/groups/${group.id}`}>
                          <div className="font-icon-detail">
                            <img
                              className="rounded-circle responsive"
                              src={
                                group.icon
                                  ? group.icon?.includes("https://") ?group.icon : `https://drive.google.com/uc?id=${group.icon}&export=download`
                                  : "https://tse3.mm.bing.net/th?id=OIP.zIHkOyk15JIO0uwHxYODJQHaHa&pid=Api&P=0"
                              }
                              alt="group-icon"
                              style={{ Width: "120px", maxHeight: "120px" }}
                            />
                            <h5 style={{ fontWeight: "bold" }}>{group.name}</h5>
                          </div>
                        </Link>
                      </Col>
                    );
                  })}
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Groups;
